<template>
  <el-form
    :model="form"
    ref="form">
    <!-- PO GENERAL -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('supplier-po')}}</h3>
      </div>
      <!-- content -->
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('rfq-id')"
          prop="rfqid"
          class="material-style">
          <el-input
            ref="firstField"
            disabled
            :value="form.rfqid"/>
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('entry-date')"
          :rules="getValidationRule('required')"
          prop="entryDate"
          class="material-style"
        >
          <date-picker
            v-model="form.entryDate"
            @change="updateModelItem('entryDate', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer-po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.po"
            @input="form.po = valueTrimLeft($event)"
            @change="updateModelItem('po', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('baxpo')"
          prop="baxpo"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.baxpo"
            @input="form.baxpo = valueTrimLeft($event)"
            @change="updateModelItem('baxpo', { required: true })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('employee')"
          prop="employeeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.employeeID"
            @update:model="updateModelItem('employeeID', { required: true })"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.loading"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('priority')"
          prop="priorityID"
          class="material-style"
        >
          <select-response
            :model.sync="form.priorityID"
            @update:model="updateModelItem('priorityID', { required: false })"
            :data="dataSourcePriority.records"
            :isLoading="dataSourcePriority.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('remarks')"
          prop="remarks"
          class="material-style"
        >
          <el-input
            :value="form.remarks"
            @input="form.remarks = valueTrimLeft($event)"
            @change="updateModelItem('remarks', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormPO',
  mixins: [Form],
  props: {
    dataID: { required: true }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title')
    }
  },
  methods: {
    updateModelItem (fieldName, payload = {}) {
      let payloadMixin = { api: `SalesOrders/Patch/${this.dataID}`, id: this.dataID }
      this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payloadMixin, ...payload })
    }
  }
}
</script>
